import { VehicleNumberPlateType } from '~/shared';

export const hintTextByType: Partial<Record<VehicleNumberPlateType, string>> = {
	[VehicleNumberPlateType.Classic]: 'Классический номер',
	[VehicleNumberPlateType.ClassicNoFlag]: 'Номер без флага',
	// [VehicleNumberPlateType.ClassicSquare]: 'Квадратный номер',
	[VehicleNumberPlateType.ClassicSquareNoFlag]: 'Квадратный номер без флага',
	[VehicleNumberPlateType.Custom]: 'Именный номер белый',
	[VehicleNumberPlateType.CustomBlack]: 'Именный номер черный',
};
